/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DevicesV2ControllerFindAllStatusItem =
  (typeof DevicesV2ControllerFindAllStatusItem)[keyof typeof DevicesV2ControllerFindAllStatusItem];

export const DevicesV2ControllerFindAllStatusItem = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  DEACTIVATED: 'deactivated',
  ARCHIVED: 'archived',
  UNPLUGGED: 'unplugged',
} as const;
